<template>
  <OmtLayoutContainer>
    <OmtRow>
      <CBox w="100%" bg="var(--colors-light-primary-light-gray)" borderRadius="8px" p="16px">
        <CBox v-if="selectedDoc">
          <CBox mb="24px" display="flex" alignItems="center">
            <OmtIcons name="circle-exclamation" size="1x" mr="8px" />
            <OmtTypography as="h2-bold"> Atenção </OmtTypography>
          </CBox>

          <CBox>
            <OmtTypography pb="8px" as="p1">
              <span class="text-terms" v-html="selectedDoc.text"></span>
            </OmtTypography>
          </CBox>

          <CBox p="0px">
            <CList v-if="selectedDoc.list.length" styleType="disc" ml="8px">
              <CBox w="100%" v-for="(most, mostIndex) in selectedDoc.mostLists" :key="`most-${mostIndex}`">
                <OmtTypography as="p0" pb="16px" color="var(--colors-lightPrimary-gray2)">
                  {{ most.title }}
                </OmtTypography>
                <CBox v-for="(item, itemIndex) of most.list" :key="`most-${mostIndex}-${itemIndex}`">
                  <CFlex pb="16px">
                    <OmtIcons :name="item.icon" size="sm" mr="2" />
                    <OmtTypography as="p0">{{ item.subtitle }}</OmtTypography>
                  </CFlex>
                  <CBox>
                    <OmtTypography
                      as="p2"
                      v-for="(subItem, subItemIndex) in item.sublist"
                      :key="`most-${mostIndex}-${itemIndex}-${subItemIndex}`"
                      :pb="subItemIndex === item.sublist.length - 1 ? '16px' : '0'"
                    >
                      <CListItem mb="6px" v-if="typeof subItem === 'string'">
                        <span v-html="subItem"></span>
                      </CListItem>
                    </OmtTypography>
                  </CBox>
                </CBox>
              </CBox>
            </CList>
          </CBox>
        </CBox>
      </CBox>
    </OmtRow>

    <!-- Action Button -->
    <OmtRow mt="48px" justifyContent="center">
      <OmtButton :w="['100%', '342px !important']" @click="proceed" class="continue-button"> Continuar </OmtButton>
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
import { mapState } from "vuex";
import { isMobile } from "@/utils/utils";

export default {
  name: "RequestInfo",
  data() {
    return {
      necessaryDocs: []
    };
  },
  computed: {
    ...mapState("request", ["newRequest", "subjectOptions"]),
    isMobile() {
      return isMobile();
    },
    indexOpen() {
      if (!this.newRequest?.subject) return -1;
      return this.newRequest.subject === 7 ? 4 : this.newRequest.subject - 1;
    },
    isOtherMatters() {
      return this.subjectOptions.find(s => s.value === this.newRequest.subject)?.outros || false;
    },
    selectedDoc() {
      const i = this.indexOpen;
      if (i < 0) return null;
      return this.necessaryDocs[i] || null;
    }
  },
  methods: {
    init() {
      let necessaryDocs = [];
      if (this.subjectOptions?.length) {
        necessaryDocs = this.subjectOptions.map(o => {
          const doc = {
            title: o.label,
            text: o.warningOrientation
              ? `<span style='color: var(--colors-light-support-error)'>${o.warningOrientation}</span>`
              : o.orientation,
            list: o.attchamentType?.length
              ? [
                  {
                    subtitle: o.attchamentType,
                    icon: "file-waveform",
                    sublist: (o.attchamentDsc ?? []).map(a => a.dsc)
                  }
                ]
              : [],
            mostLists: [],
            alert: o.warningDays,
            outros: o.outros || false
          };
          return doc;
        });
      }
      this.necessaryDocs = necessaryDocs;
    },
    shouldShowAlert(title) {
      return title !== "Análise de Cobertura Médica" && title !== "Análise de Cobertura Odontológica";
    },
    OpenwhatsApp() {
      let link = "https://wa.me/5511999351140";
      if (this.isMobile) {
        window.location = `${link}?text=Ol%C3%A1`;
      } else {
        window.open(link, "_blank", "noopener,noreferrer");
      }
    },
    proceed() {
      // Navigate to the next step based on the subject type
      if (this.newRequest?.subject) {
        const subject = this.subjectOptions.find(s => s.value === this.newRequest.subject);
        if (this.isOtherMatters) {
          this.$router.push({
            name: "request.observation.outros",
            params: {
              requireAuth: this.requireAuth
            }
          });
          return;
        } else if (subject?.attchamentType) {
          this.$router.push("/solicitacoes/upload");
        } else {
          this.$router.push("/solicitacoes/observacao");
        }
      } else {
        // Fallback navigation
        this.$router.push("/solicitacoes/upload");
      }
    }
  },
  watch: {
    subjectOptions: {
      immediate: true,
      handler() {
        this.init();
      }
    }
  },
  mounted() {
    // Check if user has permission
    if (!this.newRequest?.subject) {
      this.$router.replace("/solicitacoes/criar");
      return;
    }

    this.$root.$emit("hide-loading");
  }
};
</script>

<style scoped>
.whatsApp {
  color: var(--colors-light-primary-navy-blue);
  cursor: pointer;
}

.continue-button {
  background-color: #172972;
  border-radius: 40px;
  height: 58px;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
}
::v-deep .text-terms ul {
  margin-left: 19px;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
